export default __webpack_public_path__ + "static/media/byIcon.b1f53101.svg";